import {PartnerPageShell} from "components/commons";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import React from "react";

const GoalPlanningLumpsumPageContent = dynamic(() => import("components/Calculators/GoalPlanningLumpsum"));

const GoalPlanningLumpsumPage = ({seoData}) => (
  <PartnerPageShell seoData={seoData}>
    <GoalPlanningLumpsumPageContent />
  </PartnerPageShell>
);

export async function getStaticProps() {
  const seoData = {
    title: "Goal Planning Lumpsum Calculator for MFDs | Wealthy",
    description:
      "Use Wealthy's Goal Planning Lumpsum Calculator to estimate the one-time investment needed to reach a target corpus from expected returns and tenure.",
    keywords:
      "goal planning, lumpsum calculator, lump sum calculator, lump sum mutual fund calculator, lump sum return calculator",
    canonicalUrl: `${WealthyEnv.URL}/partner/calculators/goal-planning-lumpsum`,
    ogImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-og-image.jpg`,
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Calculators",
              item: `${WealthyEnv.URL}/partner/calculators`
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Goal Planning Lumpsum Calculator",
              item: `${WealthyEnv.URL}/partner/calculators/goal-planning-lumpsum`
            }
          ]
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What is a Goal Planning Lumpsum Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "A Goal Planning Lumpsum Calculator is an online planning tool that estimates the one-time investment needed today to reach a future financial goal. It uses the target corpus, the investment tenure, and the expected annual return to arrive at the required investment amount."
              }
            },
            {
              "@type": "Question",
              name: "How does a Goal Planning Lumpsum Calculator work?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The calculator works back from the goal. Given the target corpus and the number of years available, it uses the expected annual return to calculate the present investment that would compound to reach that target over the chosen period."
              }
            },
            {
              "@type": "Question",
              name: "Can the Goal Planning Lumpsum Calculator be used for retirement planning?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. Retirement is one of the most common uses. The same tool applies equally to other long-term goals such as a child's higher education, a home purchase, business expansion, or general wealth creation."
              }
            },
            {
              "@type": "Question",
              name: "Are the calculator results guaranteed?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "No. The results are indicative, based on the values entered by the user. Actual outcomes depend on market performance, taxation, expenses, and other variables. Mutual fund investments do not guarantee returns."
              }
            },
            {
              "@type": "Question",
              name: "Why should Mutual Fund Distributors use this calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The calculator gives distributors a fast way to run goal-based planning conversations with clients, backed by visual projections rather than back-of-envelope estimates. It supports scenario comparison in real time, keeps the meeting focused on the client's situation rather than the maths, and turns generic advice into a specific plan."
              }
            }
          ]
        }
      ]
    }
  };

  return {
    props: {
      seoData
    }
  };
}

export default GoalPlanningLumpsumPage;
